import { Box, Heading, Text } from '@homebotapp/hb-react-component-catalog'
import { defineMessages, useIntl } from 'react-intl'
import { NEW_STEPS, OnboardingStep } from '../../../../constants/client/onboarding'

const MSG = defineMessages({
  whatAreYouLookingToDo: {
    id: 'BuyerOnboarding.whatAreYouLookingToDo',
    defaultMessage: 'What are you looking to do?'
  },
  youCanAlwaysChangeThisLater: {
    id: 'BuyerOnboarding.youCanAlwaysChangeThisLater',
    defaultMessage: 'You can always change this later'
  },
  closeDate: {
    id: 'BuyerOnboarding.closeDate',
    defaultMessage: 'Is there a date you want to close by?'
  },
  thisCanBeAGuess: {
    id: 'BuyerOnboarding.thisCanBeAGuess',
    defaultMessage: 'This can be a guess, you can update it any time'
  },
  budget: {
    id: 'BuyerOnboarding.budget',
    defaultMessage: 'Do you have a budget in mind?'
  },
  noWorriesIfNot: {
    id: 'BuyerOnboarding.noWorriesIfNot',
    defaultMessage: "No worries if not, we'll help you get there"
  }
})

interface OnboardingModalTitleProps {
  currentStep: OnboardingStep
}

export const OnboardingModalTitle = ({ currentStep }: OnboardingModalTitleProps) => {
  const intl = useIntl()

  const getHeadlineMessage = () => {
    switch (currentStep) {
      case NEW_STEPS.BUYER_GOALS:
        return intl.formatMessage(MSG.whatAreYouLookingToDo)
      case NEW_STEPS.BUYER_CLOSE_DATE:
        return intl.formatMessage(MSG.closeDate)
      case NEW_STEPS.BUYER_ONBOARDED:
        return intl.formatMessage(MSG.budget)
      default:
        return null
    }
  }

  const getSubheadlineMessage = () => {
    switch (currentStep) {
      case NEW_STEPS.BUYER_GOALS:
        return intl.formatMessage(MSG.youCanAlwaysChangeThisLater)
      case NEW_STEPS.BUYER_CLOSE_DATE:
        return intl.formatMessage(MSG.thisCanBeAGuess)
      case NEW_STEPS.BUYER_ONBOARDED:
        return intl.formatMessage(MSG.noWorriesIfNot)
      default:
        return null
    }
  }

  return (
    <Box>
      <Heading textAlign='left' mb={0}>
        {getHeadlineMessage()}
      </Heading>
      <Text size='sm'>{getSubheadlineMessage()}</Text>
    </Box>
  )
}
